import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// usePeople — v2 PersonPicker / PersonMultiPicker source. Hits the /api/people
// stub (25 v5 PEOPLE entries from a module-level constant on the API side).
// Catalogue-style hour-long staleTime since the people list rarely changes
// during a session.
export function usePeople() {
  return useQuery({
    queryKey: ['people'],
    queryFn: ApiClient.people,
    staleTime: 60 * 60 * 1000
  })
}
